import type { UIMessage } from "ai"

/** Tool results are persisted with coach messages and replayed on reopening. */
export function coachSuggestions(messages: UIMessage[]): string[] {
  for (const message of [...messages].reverse()) {
    if (message.role !== "assistant") continue
    for (const part of [...message.parts].reverse()) {
      if (
        part.type !== "tool-replySuggestions" ||
        part.state !== "output-available"
      )
        continue
      const output = part.output as { suggestions?: unknown } | undefined
      if (!Array.isArray(output?.suggestions)) continue
      const suggestions = [
        ...new Set(
          output.suggestions
            .filter(
              (value): value is string =>
                typeof value === "string" &&
                value.trim().length > 0 &&
                value.length <= 100
            )
            .map((value) => value.trim())
        ),
      ].slice(0, 5)
      if (suggestions.length >= 3) return suggestions
    }
  }
  return []
}
